'use strict';

export default {
    message: null,
    level: 'info',

    /**
     * Clears any notifications
     */
    clear() {
        this.message = null;
        this.level = 'info';
    },

    /**
     * Sends a notification to the front end
     * @param {string} message
     * @param {string} level
     */
    ring(message, level) {
        this.message = message;

        if (level) {
            this.level = level;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Services/Notification.js